import * as angular from 'angular';
import { TooltipWarningComponent } from './tooltip-warning.component';

export const TooltipWarningModule = angular
  .module('tooltipWarning', [])
  .component('tooltipWarning', TooltipWarningComponent).name;
